import home from './home'

const zhCN = { home: home.zhCN }
const enUS = { home: home.enUS }
export default { zhCN, enUS }